import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { firebaseConfig } from "../firebaseConfig";

const app = initializeApp({ ...firebaseConfig });

export const auth = getAuth(app);
export const realtimeDB = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();